(function () {
  const config = document.currentScript.dataset;
  let started = false;

  function start() {
    if (started) return;
    started = true;

    const clarity = document.createElement("script");
    clarity.async = true;
    clarity.src =
      "https://www.clarity.ms/tag/" + encodeURIComponent(config.clarityId);
    document.head.appendChild(clarity);

    const metricool = document.createElement("script");
    metricool.async = true;
    metricool.src = "https://tracker.metricool.com/resources/be.js";
    metricool.onload = function () {
      metricool.onload = null;
      window.beTracker.t({ hash: config.metricoolHash });
    };
    document.head.appendChild(metricool);
  }

  function schedule() {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 0);
    }
  }

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
})();
